module.exports = __webpack_public_path__ + "static/media/jgpg_logo.293f276c.png";